import { Headline1, Spacing } from '@boxine/tonies-ui'
import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import ReactMarkdown from 'react-markdown'

const Container = styled.div`
  text-align: center;
`

const DownloadButtonImage = styled.img`
  height: 50px;
`
const DownlaodButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  margin-bottom: 6rem;

  a {
    margin: 0 1rem;
  }
`

const MainCopy = styled.div`
  margin: 1rem auto 2rem auto;
  max-width: 600px;

  > p {
    margin-bottom: 1rem;
  }
`

const AppDownloadPage: React.FC = () => {
  const { t } = useTranslation()

  const playStoreLink = new URL(
    t('creative-tonie-details:ModalAndroidPlaystoreLink')
  )
  const appStoreLink = new URL(
    t('creative-tonie-details:ModalAppleAppStoreLink')
  )
  // add UTM params to be able to track the source of the download in the stores
  playStoreLink.searchParams.set('utm_source', 'mytonies-web')
  playStoreLink.searchParams.set('utm_medium', 'web')
  playStoreLink.searchParams.set('utm_campaign', 'app-download-page')
  appStoreLink.searchParams.set('utm_source', 'mytonies-web')
  appStoreLink.searchParams.set('utm_medium', 'web')
  appStoreLink.searchParams.set('utm_campaign', 'app-download-page')

  return (
    <Container>
      <Spacing mb="spacing-l" mt="spacing-l">
        <Headline1>{t('app-download-page:headline')}</Headline1>

        <MainCopy>
          <ReactMarkdown>
            {t('app-download-page:MainCopyMarkdown')}
          </ReactMarkdown>
        </MainCopy>

        <DownlaodButtonsContainer>
          <a
            href={playStoreLink.toString()}
            target="_blank"
            rel="noopener noreferrer"
            data-trackingid="apple-app-store-link"
          >
            <DownloadButtonImage
              src={
                process.env.PUBLIC_URL + '/images/download-on-the-app-store.svg'
              }
              alt={t('app-download-page:AppleAppStoreLinkText')}
            />
          </a>
          <a
            href={appStoreLink.toString()}
            target="_blank"
            rel="noopener noreferrer"
            data-trackingid="google-play-store-link"
          >
            <DownloadButtonImage
              src={
                process.env.PUBLIC_URL +
                '/images/download-on-the-google-play-store.svg'
              }
              alt={t('app-download-page:GooglePlayStoreLinkText')}
            />
          </a>
        </DownlaodButtonsContainer>
      </Spacing>
    </Container>
  )
}

export default AppDownloadPage
